export default __webpack_public_path__ + "bfb56123fa60d16963a8c65e47871b17.png";